import { useNavigate } from "react-router-dom";
import { PlayCircle, ArrowRight } from "lucide-react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { Button } from "../components/ui/button";

/**
 * Placeholder demo landing for the Transformation Portal. Linked from both
 * the Portal's "Open Demo Dashboard" secondary CTA and the post-login redirect
 * for demo-role users. Replace with the real demo experience when ready.
 */
export default function TransformationDemo() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex flex-col bg-[#F8FAFC]">
      <Header variant="solid" />
      <main className="flex-1 flex items-center justify-center py-20">
        <div className="max-w-lg mx-auto px-6 text-center">
          <span className="inline-flex items-center gap-1.5 bg-[#E0F2FE] border border-[#025979]/20 rounded-sm px-2.5 py-1 text-[11px] font-semibold text-[#025979]">
            <PlayCircle className="w-3 h-3" strokeWidth={2.25} />
            Demo Preview
          </span>
          <h1
            className="mt-4 text-3xl sm:text-4xl font-bold text-[#0F172A] tracking-tight"
            style={{ fontFamily: "Chivo, sans-serif" }}
            data-testid="demo-dashboard-title"
          >
            Demo Transformation Dashboard
          </h1>
          <p className="mt-4 text-base text-[#4B5563] leading-relaxed">
            A guided sample of the WarehouseX client experience — recommendations,
            initiative selection, execution tracking, and ROI roll-up. The
            interactive demo is being finalized and will be available here soon.
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <Button
              data-testid="demo-dashboard-back-btn"
              onClick={() => navigate("/app")}
              variant="outline"
              className="border border-[#E5E7EB] text-[#0F172A] hover:bg-[#F3F4F6] rounded-sm h-10 px-5 text-sm font-semibold"
            >
              Go to Dashboard
              <ArrowRight className="w-4 h-4 ml-1.5" />
            </Button>
            <Button
              data-testid="demo-dashboard-evaluate-btn"
              onClick={() => navigate("/evaluate")}
              className="bg-[#025979] hover:bg-[#03738C] text-white rounded-sm h-10 px-5 text-sm font-semibold"
            >
              Start Your Own Evaluation
            </Button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
